import gql from 'graphql-tag';

export const ListContractorsQuery = gql`
  query ListContractorsQuery{
    contactContractors {
        id
        fullName
        businessName
        emailAddress1
        emailAddress2
        telephone1
        address2_Line1
        address2_Line2
        address2_City
        address2_StateOrProvince
        address2_PostalCode
        address2_Telephone1
        address2_Latitude
        address2_Longitude
        webSiteUrl
        contractorLicenseNumber
        contractorLicenseExpiration
        advertiseYourself
        hasReview
    }
  }
`;

export const ListContractorsZipQuery = gql`
         query contactContractorsProximityZIP($zip: String, $programtypes: String) {
           contactContractorsProximityZIP(zipcode: $zip, programtypes: $programtypes) {
             id
             fullName
             businessName
             emailAddress1
             emailAddress2
             telephone1
             address2_Line1
             address2_Line2
             address2_City
             address2_StateOrProvince
             address2_PostalCode
             address2_Telephone1
             address2_Latitude
             address2_Longitude
             webSiteUrl
             contractorLicenseNumber
             contractorLicenseExpiration
             advertiseYourself
             hasReview
             contractorInDirectory
             essContractorInDirectory
             emrContractorInDirectory
           }
         }
       `;

export const ListContractorsFilterQuery = gql`
         query contactContractorsFilter($filter: String, $programtypes: String) {
           contactContractorsFilter(filter: $filter, programtypes: $programtypes) {
             id
             fullName
             businessName
             emailAddress1
             emailAddress2
             telephone1
             address2_Line1
             address2_Line2
             address2_City
             address2_StateOrProvince
             address2_PostalCode
             address2_Telephone1
             address2_Latitude
             address2_Longitude
             webSiteUrl
             contractorLicenseNumber
             contractorLicenseExpiration
             advertiseYourself
             hasReview
             contractorInDirectory
             essContractorInDirectory
             emrContractorInDirectory
           }
         }
       `;

export const GetContractorByIdQuery = gql`
  query GetContractorByIdQuery($id: String, $resetCache:Boolean){
    contact(id: $id, resetCache: $resetCache) {
      id
      fullName
      businessName
      emailAddress1
      emailAddress2
      telephone1
      address2_Line1
      address2_Line2
      address2_City
      address2_StateOrProvince
      address2_PostalCode
      address2_Telephone1
      address2_Latitude
      address2_Longitude
      webSiteUrl
      contractorLicenseNumber
      contractorLicenseExpiration
      contractorInDirectory
      contractorManualEntry
      femaTrained
      essFemaTrained
      emrFemaTrained
      advertiseYourself
      hasReview
      createdOn
      essContractorInDirectory
      emrContractorInDirectory
    }
  }
`;
